var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    svg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 480,
    id: "svg3122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3124"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0174321,0,0,1.0174321,-11.654274,-8.4600032)",
    id: "g3157"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 39.5321,349.1496 L 114.27469,349.1496 L 114.27469,380.4515 L 80.215253,380.4515 L 80.215253,391.38854 L 111.33083,391.38854 L 111.33083,421.17192 L 80.215253,421.17192 L 80.215253,432.41639 L 115.45783,432.41639 L 115.45783,463.71827 L 39.5321,463.71827 L 39.5321,349.1496 z",
    id: "path2604",
    style: {
      fill: "#e30018",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 229.23091,349.1496 L 229.23091,416.91449 C 229.23091,450.34976 208.88468,465.54421 177.77843,465.54421 C 146.67217,465.54421 126.33525,450.34976 126.33525,416.91449 L 126.33525,349.1496 L 166.72961,349.1496 L 166.72961,412.96449 C 166.72961,421.93584 167.0184,429.83584 177.77843,429.83584 C 188.53845,429.83584 188.83657,421.93584 188.83657,412.96449 L 188.83657,349.1496 L 229.23091,349.1496 z",
    id: "path2616",
    style: {
      fill: "#e30018",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 241.90163,349.1496 L 290.69905,349.1496 C 315.7592,349.1496 336.99047,360.08663 336.99047,388.95705 C 336.99047,406.28489 330.49719,413.57003 315.46109,418.74043 L 315.46109,419.65341 C 317.52926,421.32097 346.42761,463.71827 346.42761,463.71827 L 299.83809,463.71827 L 282.14694,426.94787 L 281.41096,426.94787 L 281.41096,463.71827 L 241.90163,463.71827 L 241.90163,349.1496 z M 281.41096,399.89408 L 284.2151,399.89408 C 290.84813,399.89408 297.48113,398.83204 297.48113,390.3265 C 297.48113,381.51353 291.43503,380.4515 284.50389,380.4515 L 281.41096,380.4515 L 281.41096,399.89408 z",
    id: "path2620",
    style: {
      fill: "#e30018",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 467.28648,406.73674 C 467.28648,443.50716 439.72032,465.54892 405.80993,465.54892 C 371.89955,465.54892 344.33337,443.50716 344.33337,406.73674 C 344.33337,370.72095 372.04859,347.31903 405.80993,347.31903 C 439.57125,347.31903 467.28648,370.72095 467.28648,406.73674 M 385.02583,407.3516 C 385.02583,420.4127 393.57797,429.37472 405.80993,429.37472 C 418.04189,429.37472 426.59401,420.4127 426.59401,407.3516 C 426.59401,395.18487 418.63812,385.00244 405.80993,385.00244 C 392.98174,385.00244 385.02583,395.18487 385.02583,407.3516",
    id: "path2624",
    style: {
      fill: "#e30018",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 476.69195,349.1496 L 517.82213,349.1496 C 555.12355,349.1496 583.7238,366.01163 583.7238,408.10152 C 583.7238,442.14232 560.42476,463.71827 527.84619,463.71827 L 476.69195,463.71827 L 476.69195,349.1496 z M 517.08654,429.37934 L 519.59218,429.37934 C 533.00727,429.37934 543.32945,422.99787 543.32945,407.95246 C 543.32945,391.84502 534.33985,385.00705 519.59218,385.00705 L 517.08654,385.00705 L 517.08654,429.37934 z",
    id: "path2628",
    style: {
      fill: "#e30018",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 593.14343,349.1496 L 641.94086,349.1496 C 667.001,349.1496 688.2319,360.08663 688.2319,388.95705 C 688.2319,406.28489 681.74868,413.57003 666.70291,418.74043 L 666.70291,419.65341 C 668.77107,421.32097 697.66048,463.71827 697.66048,463.71827 L 651.07952,463.71827 L 633.38874,426.94787 L 632.65239,426.94787 L 632.65239,463.71827 L 593.14343,463.71827 L 593.14343,349.1496 z M 632.65239,399.89408 L 635.4569,399.89408 C 642.08991,399.89408 648.72294,398.83204 648.72294,390.3265 C 648.72294,381.51353 642.67645,380.4515 635.74532,380.4515 L 632.65239,380.4515 L 632.65239,399.89408 z",
    id: "path2632",
    style: {
      fill: "#e30018",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 702.52866,349.14685 L 742.92302,349.14685 L 742.92302,463.71554 L 702.52866,463.71554 L 702.52866,349.14685 z",
    id: "path2634",
    style: {
      fill: "#e30018",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 868.38103,349.1496 L 825.33198,463.71827 L 791.13243,463.71827 L 748.08336,349.1496 L 790.24703,349.1496 L 804.98575,401.26354 C 806.61567,406.89044 807.7895,412.508 807.7895,418.28395 L 808.67491,418.28395 C 808.67491,412.508 809.84872,406.89044 811.4697,401.26354 L 826.21663,349.1496 L 868.38103,349.1496 z",
    id: "path2646",
    style: {
      fill: "#e30018",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 871.61854,349.1496 L 946.36077,349.1496 L 946.36077,380.4515 L 912.30132,380.4515 L 912.30132,391.38854 L 943.4169,391.38854 L 943.4169,421.17192 L 912.30132,421.17192 L 912.30132,432.41639 L 947.54427,432.41639 L 947.54427,463.71827 L 871.61854,463.71827 L 871.61854,349.1496 z",
    id: "path2650",
    style: {
      fill: "#e30018",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 58.854552,224.75438 L 64.546658,229.2354 C 84.501624,244.70001 108.51836,257.31393 134.1561,257.31393 C 145.14904,257.31393 162.64456,252.84224 162.64456,238.9986 C 162.64456,225.16428 147.99974,223.94386 137.81731,221.90366 L 115.43086,217.83255 C 71.878359,210.10025 35.247707,184.46249 35.247707,136.42899 C 35.247707,63.568242 101.59654,22.857143 168.34597,22.857143 C 203.35566,22.857143 235.51462,31.40926 265.63338,49.724599 L 235.51462,128.28676 C 216.37948,115.26295 194.80352,105.08052 170.78677,105.08052 C 161.02355,105.08052 146.77933,108.75103 146.77933,121.36496 C 146.77933,132.76777 160.61365,134.38877 169.15645,136.42899 L 194.40295,142.12109 C 241.61663,152.7041 275.80651,177.95057 275.80651,230.04587 C 275.80651,303.31654 209.05707,339.53731 142.69891,339.53731 C 104.03734,339.53731 59.264456,328.95429 24.664675,311.45877 L 58.854552,224.75438 z",
    id: "path2662",
    style: {
      fill: "#e30018",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 294.49911,27.744327 L 500.86841,27.744327 L 500.86841,111.59802 L 406.84125,111.59802 L 406.84125,140.90626 L 492.73515,140.90626 L 492.73515,220.68884 L 406.84125,220.68884 L 406.84125,250.8076 L 504.12905,250.8076 L 504.12905,334.66129 L 294.49911,334.66129 L 294.49911,27.744327 z",
    id: "path2666",
    style: {
      fill: "#e30018",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 613.54705,27.744327 L 652.01262,204.99132 L 696.58056,27.744327 L 782.06529,27.744327 L 823.89357,204.99132 L 865.09879,27.744327 L 981.11109,27.744327 L 872.8408,334.66129 L 775.55302,334.66129 L 740.54334,167.77375 L 700.25182,334.66129 L 605.40484,334.66129 L 497.94392,27.744327 L 613.54705,27.744327 z",
    id: "path2670",
    style: {
      fill: "#e30018",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSew);
export default __webpack_public_path__ + "static/media/sew.7bc65e35b7f2aca7991a821971005101.svg";
export { ForwardRef as ReactComponent };